import React, { createContext, useContext, useState } from "react";

const FilterProjectsContext = createContext();

export const useFilter = () => useContext(FilterProjectsContext);

export const FilterProjectsProvider = ({ children }) => {
  const [selectedFilter, setSelectedFilter] = useState("overview");
  const [activeFolder, setActiveFolder] = useState("overview"); // Yeni filtre

  return (
    <FilterProjectsContext.Provider
      value={{
        selectedFilter,
        setSelectedFilter,
        activeFolder,
        setActiveFolder,
      }}
    >
      {children}
    </FilterProjectsContext.Provider>
  );
};
